"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var Notifications_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const event_bus_1 = require("@completeanatomy/event-bus");
const http_1 = require("@completeanatomy/http");
const sharing_1 = require("@completeanatomy/sharing");
const store_1 = require("@completeanatomy/store");
const websocket_1 = require("@completeanatomy/websocket");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
require("reflect-metadata");
const typedi_1 = require("typedi");
const WebSocketEvent_1 = require("./types/WebSocketEvent");
const utils_1 = require("./utils");
let Notifications = Notifications_1 = class Notifications {
    constructor(bridge, http, eventBus, websocket, store, sharing) {
        this.bridge = bridge;
        this.http = http;
        this.eventBus = eventBus;
        this.websocket = websocket;
        this.store = store;
        this.sharing = sharing;
        this.appStateIdentifier = 'userNotifications';
        this.bridge.emit(bridge_schema_1.bridgeObjectAdded, {
            identifier: this.appStateIdentifier,
            object: [],
        });
        this.eventBus.on(event_bus_1.AuthEvent.Authenticated, () => __awaiter(this, void 0, void 0, function* () {
            yield this.fetch();
        }));
        this.eventBus.on(event_bus_1.AuthEvent.NeedClearUserData, () => {
            this.clearAppState();
        });
        this.websocket.on(WebSocketEvent_1.WebSocketEvent.NewNotification, this.handleNewNotification, this);
    }
    fetch() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.get({
                path: 'notifications/',
            });
            const notifications = yield response.json();
            const groups = this.store.getState().userGroups;
            const result = notifications.map((notification) => {
                return Notifications_1.transformToAppStateFormat(notification, groups);
            });
            const syncNotify = this.getSyncNotification();
            this.overwriteAppState([...syncNotify, ...result]);
        });
    }
    markAsRead(id) {
        return __awaiter(this, void 0, void 0, function* () {
            /**
             * Do not send request to the server if that's a special notification (Sync)
             */
            if (id < 0) {
                return;
            }
            yield this.changeStatus({
                id,
                status: bridge_schema_1.NotificationStatus.Read,
            });
        });
    }
    markAsUnread(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.changeStatus({
                id,
                status: bridge_schema_1.NotificationStatus.Unread,
            });
        });
    }
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.http.delete({
                path: `notifications/${id}/`,
            });
            const { userNotifications: notifications = [] } = this.store.getState();
            const updatedNotifications = notifications.filter(notification => notification.identifier !== id);
            this.overwriteAppState(updatedNotifications);
        });
    }
    startContentSync() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { userNotifications: notifications = [] } = this.store.getState();
            notifications[0] = Object.assign(Object.assign({}, notifications[0]), { timestamp: Date.now(), type: bridge_schema_1.NotificationType.SyncComplete });
            // @ts-ignore
            yield ((_b = (_a = window.Manager) === null || _a === void 0 ? void 0 : _a.SyncManager) === null || _b === void 0 ? void 0 : _b.synchronization_content({
                success: () => this.overwriteAppState(notifications),
                error: () => this.overwriteAppState(notifications),
                updateCallBack: () => { },
            }));
        });
    }
    ignoreContentSync() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { userNotifications: notifications = [] } = this.store.getState() || [];
            const filteredNotifications = notifications.slice(1);
            // @ts-ignore
            yield ((_b = (_a = window.Manager) === null || _a === void 0 ? void 0 : _a.SyncManager) === null || _b === void 0 ? void 0 : _b.ignoreSync());
            this.overwriteAppState(filteredNotifications);
        });
    }
    clearSyncNotification() {
        const { userNotifications: notifications = [] } = this.store.getState() || [];
        const filteredNotifications = notifications.slice(1);
        this.overwriteAppState(filteredNotifications);
    }
    getSyncNotification() {
        var _a, _b, _c, _d;
        const notifications = [];
        // @ts-ignore
        const syncNotify = (_b = (_a = window.Manager) === null || _a === void 0 ? void 0 : _a.SyncManager) === null || _b === void 0 ? void 0 : _b.getNotify();
        // @ts-ignore
        const notifyContent = (_d = (_c = window.Manager) === null || _c === void 0 ? void 0 : _c.SyncManager) === null || _d === void 0 ? void 0 : _d.content;
        if (!(0, isEmpty_1.default)(syncNotify) && !(0, isEmpty_1.default)(notifyContent)) {
            const syncNotification = new utils_1.SyncNotification(notifyContent);
            notifications.push(syncNotification);
        }
        return notifications;
    }
    changeStatus({ id, status, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.patch({
                path: `notifications/${id}/`,
                data: {
                    status,
                },
            });
            const notification = yield response.json();
            const groups = this.store.getState().userGroups;
            const transformedNotification = Notifications_1.transformToAppStateFormat(notification, groups);
            const { userNotifications: notifications = [] } = this.store.getState();
            const updatedNotifications = (0, utils_1.updateOrPush)(notifications, transformedNotification, 'identifier');
            this.overwriteAppState(updatedNotifications);
        });
    }
    static transformToAppStateFormat(notification, groups = []) {
        var _a;
        const timestamp = +Date.parse(notification.modified_timestamp);
        const result = {
            identifier: notification.id,
            type: notification.type,
            status: notification.status,
            timestamp,
        };
        if (notification.data) {
            const data = notification.data;
            if ('user' in data && 'user_group' in data) {
                const user = data.user;
                result.user = {
                    identifier: user.id,
                    name: user.username,
                    avatar: user.image_url,
                };
                const group = data.user_group;
                result.group = {
                    identifier: group.id,
                    name: group.name,
                    avatar: group.image,
                };
            }
            else {
                result.message = {
                    button: data.button || undefined,
                    code: data.code || undefined,
                    description: data.description,
                    image: data.image,
                    name: data.name,
                    url: data.url || undefined,
                };
                // eslint-disable-next-line max-depth
                if ('user_group_id' in data && data.user_group_id !== null) {
                    const group = groups.find(userGroup => userGroup.identifier === data.user_group_id);
                    result.group = {
                        identifier: data.user_group_id,
                        name: (_a = group === null || group === void 0 ? void 0 : group.name) !== null && _a !== void 0 ? _a : '',
                        avatar: group === null || group === void 0 ? void 0 : group.avatar,
                    };
                }
            }
        }
        if (notification.user) {
            const user = notification.user;
            result.user = {
                identifier: user.id,
                name: user.username,
                avatar: user.image_url,
            };
        }
        if (notification.user_group) {
            const group = notification.user_group;
            result.group = {
                identifier: group.id,
                name: group.name,
                avatar: group.image,
            };
        }
        if (notification.membership) {
            const { membership } = notification;
            result.membership = {
                identifier: membership.id,
                status: membership.status,
            };
        }
        return result;
    }
    overwriteAppState(notifications) {
        this.bridge.emit(bridge_schema_1.bridgeObjectChanged, {
            identifier: this.appStateIdentifier,
            keyPath: '',
            changes: notifications,
        });
    }
    clearAppState() {
        this.bridge.emit(bridge_schema_1.bridgeObjectChanged, {
            identifier: this.appStateIdentifier,
            keyPath: '',
            changes: [],
        });
    }
    handleNewNotification(message) {
        var _a, _b, _c;
        const groups = this.store.getState().userGroups;
        const notification = Notifications_1.transformToAppStateFormat(message.data, groups);
        if (notification.type === bridge_schema_1.NotificationType.Kick) {
            this.sharing.fetch();
            // @ts-ignore
            (_c = (_b = (_a = window.Manager) === null || _a === void 0 ? void 0 : _a.GroupsManager) === null || _b === void 0 ? void 0 : _b.loadGroups) === null || _c === void 0 ? void 0 : _c.call(_b);
        }
        const { userNotifications: notifications = [] } = this.store.getState();
        this.overwriteAppState([...notifications, notification]);
    }
};
exports.Notifications = Notifications;
Notifications.exportName = 'notifications';
exports.Notifications = Notifications = Notifications_1 = __decorate([
    (0, typedi_1.Service)(),
    __param(4, (0, typedi_1.Inject)(store_1.StoreToken)),
    __metadata("design:paramtypes", [bridge_schema_1.BridgeInterface,
        http_1.HTTP,
        event_bus_1.EventBus,
        websocket_1.WebSocketManager, Object, sharing_1.Sharing])
], Notifications);
